<div class="company-list-toolbar">
  <input
    class="form-control company-list-search"
    type="search"
    [placeholder]="searchPlaceholder"
    [ngModel]="searchTerm"
    (ngModelChange)="searchTermChange.emit($event)"
  />
  <button
    *ngIf="showRefresh"
    type="button"
    class="btn btn-outlined btn-medium"
    (click)="refresh.emit()"
    [disabled]="loading"
  >
    Refresh
  </button>
</div>

<div class="company-list-state" *ngIf="loading">{{ loadingMessage }}</div>
<div class="company-list-state company-list-state--error" *ngIf="!loading && errorMessage">
  {{ errorMessage }}
</div>
<div class="company-list-state" *ngIf="!loading && !errorMessage && companies.length === 0">
  {{ emptyMessage }}
</div>

<div class="company-list-table-wrap" *ngIf="!loading && companies.length > 0">
  <table class="company-list-table">
    <thead>
      <tr>
        <th>{{ nameHeader }}</th>
        <th *ngIf="has('email')">Email</th>
        <th *ngIf="has('contact')">Contact</th>
        <th *ngIf="has('locations')">Locations</th>
        <th>Status</th>
        <th *ngIf="has('created')">Created</th>
        <th *ngIf="menuTemplate" class="company-list-table__action-head">
          <span class="company-list-sr-only">Actions</span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let company of companies; trackBy: trackById"
        [class.is-clickable]="rowsAreLinked"
        (click)="onRowClick(company, $event)"
      >
        <td class="company-list-table__name-cell">
          <div class="company-list-cell">
            <div class="company-list-cell__logo" aria-hidden="true">
              <img
                *ngIf="logoUrl(company) as url"
                [src]="url"
                [alt]="''"
                (error)="onLogoError(company)"
              />
              <span *ngIf="!logoUrl(company)">{{ companyInitials(company.name) }}</span>
            </div>
            <a
              *ngIf="rowsAreLinked; else plainName"
              class="company-list-table__name company-list-table__name-link"
              [routerLink]="rowLink(company)"
            >
              {{ company.name }}
            </a>
            <ng-template #plainName>
              <span class="company-list-table__name">{{ company.name }}</span>
            </ng-template>
          </div>
        </td>
        <td *ngIf="has('email')">{{ company.email || '—' }}</td>
        <td *ngIf="has('contact')">{{ company.contact || '—' }}</td>
        <td *ngIf="has('locations')">{{ locationsLabel(company) }}</td>
        <td>
          <span
            class="company-list-pill"
            [class.company-list-pill--off]="company.is_active === false"
          >
            {{ company.is_active === false ? 'Inactive' : 'Active' }}
          </span>
        </td>
        <td *ngIf="has('created')">{{ formatDate(company.created_at) }}</td>
        <td *ngIf="menuTemplate" class="company-list-table__action">
          <div class="company-list-menu">
            <button
              type="button"
              class="company-list-menu__trigger"
              [attr.aria-label]="'Actions for ' + company.name"
              aria-haspopup="menu"
              [attr.aria-expanded]="openMenuCompanyId === company.id"
              (click)="toggleMenu(company, $event)"
            >
              <span aria-hidden="true">⋯</span>
            </button>

            <div
              class="company-list-menu__panel"
              role="menu"
              *ngIf="openMenuCompanyId === company.id"
              [style.top.px]="menuPanelTop"
              [style.right.px]="menuPanelRight"
              (click)="onMenuClick($event)"
            >
              <ng-container
                *ngTemplateOutlet="menuTemplate; context: { $implicit: company }"
              ></ng-container>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<app-pagination-bar
  *ngIf="paginationData.totalItems > 0"
  [paginationData]="paginationData"
  [itemsPerPageOptions]="itemsPerPageOptions"
  (pageChange)="pageChange.emit($event)"
  (itemsPerPageChange)="itemsPerPageChange.emit($event)"
></app-pagination-bar>
